import React from 'react';

const INTENT_LABELS = {
	ignore: 'Ignored',
	resolve_bare: 'RESOLVE',
	resolve_index: 'RESOLVE N',
	resolve_all: 'RESOLVE ALL',
	confirm_assumed: 'Confirm',
	pick_alternative: 'Pick',
	other: 'Other',
};

const SmsResponseTable = ({
	items,
	sortBy,
	sortOrder,
	onSort,
	onViewDetails,
}) => {
	const formatDate = (dateString) => {
		if (!dateString) return '-';
		return dateString;
	};

	const getSortIcon = (column) => {
		if (sortBy !== column) {
			return <i className="bi bi-arrow-down-up text-muted ms-1" />;
		}
		return sortOrder === 'asc' ? (
			<i className="bi bi-arrow-up ms-1" />
		) : (
			<i className="bi bi-arrow-down ms-1" />
		);
	};

	const intentBadge = (intent) => {
		if (!intent) {
			return <span className="text-muted">—</span>;
		}
		const tone =
			intent === 'ignore'
				? 'bg-secondary'
				: intent === 'other'
				? 'bg-warning'
				: 'bg-info';
		return (
			<span className={`badge ${tone}`}>
				{INTENT_LABELS[intent] || intent}
			</span>
		);
	};

	return (
		<div className="table-responsive">
			<table className="table table-hover mb-0">
				<thead className="table-light">
					<tr>
						<th
							style={{ cursor: 'pointer' }}
							onClick={() => onSort('created_at')}
						>
							When {getSortIcon('created_at')}
						</th>
						<th>User</th>
						<th
							style={{ cursor: 'pointer' }}
							onClick={() => onSort('from_phone')}
						>
							From {getSortIcon('from_phone')}
						</th>
						<th>Inbound Text</th>
						<th
							style={{ cursor: 'pointer' }}
							onClick={() => onSort('parsed_intent')}
						>
							Intent {getSortIcon('parsed_intent')}
						</th>
						<th>App Reply</th>
						<th>Team</th>
						<th className="text-end">Actions</th>
					</tr>
				</thead>
				<tbody>
					{items.map((row) => (
						<tr key={row.id}>
							<td>
								<small>{formatDate(row.created_at)}</small>
							</td>
							<td>
								{row.user ? (
									<div>
										<div className="fw-medium">{row.user.name}</div>
										<small className="text-muted">{row.user.email}</small>
									</div>
								) : (
									<span className="text-muted">Unmatched</span>
								)}
							</td>
							<td>
								<code>{row.from_phone || '—'}</code>
							</td>
							<td>
								<div className="text-truncate" style={{ maxWidth: '240px' }}>
									{row.body || <span className="text-muted">Empty</span>}
								</div>
							</td>
							<td>{intentBadge(row.parsed_intent)}</td>
							<td>
								<div className="text-truncate" style={{ maxWidth: '200px' }}>
									{row.reply_body || <span className="text-muted">—</span>}
								</div>
							</td>
							<td>
								{row.team_notified ? (
									<span className="badge bg-success">notified</span>
								) : (
									<span className="text-muted">—</span>
								)}
							</td>
							<td className="text-end">
								<button
									className="btn btn-sm btn-primary"
									onClick={() => onViewDetails(row)}
									title="View Details"
								>
									<i className="bi bi-eye" />
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default SmsResponseTable;
